const AUTH_TOKEN_KEY = "token";const AUTH_USER_KEY = "user";

let logoutInProgress = false;

const isLoginRequest = (config) => {
  const url = config?.url || "";
  return /\/login(\?|$)/.test(url);
};

const isLogoutRequest = (config) => {
  const url = config?.url || "";
  return /\/logout(\?|$)/.test(url);
};

export const getAuthToken = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }

  return localStorage.getItem(AUTH_TOKEN_KEY);
};

export const clearAuthSession = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }

  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
};

export const shouldLogoutOnUnauthorized = (error) => {
  if (error?.response?.status !== 401) {
    return false;
  }

  if (isLogoutRequest(error?.config)) {
    return false;
  }

  return Boolean(getAuthToken()) && !isLoginRequest(error?.config);
};

export const logoutOnExpiredSession = () => {
  if (logoutInProgress) {
    return;
  }

  logoutInProgress = true;

  if (typeof window !== "undefined") {
    import("./locationTracker")
      .then(({ stopLocationTracker }) => stopLocationTracker())
      .catch(() => {});
  }

  clearAuthSession();

  if (typeof window === "undefined") {
    return;
  }

  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};
